import { isEnumValue } from "web_myplann/Shared/Utils/parsers";

export const parseEnumValue = <TEnum extends Record<string, string>>(
	enumObject: TEnum,
	raw: unknown,
): TEnum[keyof TEnum] | undefined =>
	isEnumValue(enumObject, raw) ? raw : undefined;
